<template>
  <div class="proportional-grid">
    <svg
      class="proportional-grid__svg"
      xmlns="http://www.w3.org/2000/svg"
      :width="width"
      :height="height"
      :viewBox="svgViewBox"
      v-if="gridConfiguration.length > 0"
    >
      <g
        class="proportional-grid__grid-row"
        v-for="row in gridConfiguration"
      >
        <g
          class="proportional-grid__grid-column"
          v-for="column in row"
        >
          <rect
            class="proportional-grid__cell"
            :width="column.width"
            :height="column.height"
            :fill="column.fill"
            :stroke="column.stroke"
            :x="column.x"
            :y="column.y"
          ></rect>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "TheProportionalGridOverlay",
  props: {
    width: {
      required: true,
    },
    height: {
      required: true,
    },
    columns: {
      type: Number,
      required: true,
    },
    rows: {
      type: Number,
      required: true,
    }
  },
  data: function () {
    return {
      gridConfiguration: [],
      updateInterval: null,
    }
  },
  computed: {
    svgViewBox: function () {
      return `1 1 ${this.width} ${this.height}` // единицы нужны, чтобы не было видно границ сетки
    },
  },
  methods: {
    /**
     * Генерирует конфигурационный массив для пропорциональной svg сетки
     * @param { Number } columns - Количество колонок сетки
     * @param { Number } rows - Количество рядов сетки
     * @param { Number } width - Ширина svg контейнера
     * @param { Number } height - Высота svg контейнера
     * @param { String } fill - Цвет заливки сетки
     * @param { String } stroke - Цвет линий сетки
     */
    generateProportionalGrid(columns, rows, width, height, fill='transparent', stroke='#fdcf30') {
      if (!width || !height) {
        console.warn('Ошибка чтения параметров контейнера, свяжитесь с фиксиками')
        return
      }
      this.gridConfiguration = []
      let rectWidth = width / columns + 1 // + 1, чтобы не было видно границ сетки
      let rectHeight = height / rows + 1

      for (let i = 0; i < this.rows; i++) {
        let rowConfig = []
        for (let j = 0; j < this.columns; j++) {
          rowConfig.push({
            width: rectWidth,
            height: rectHeight,
            fill: fill,
            stroke: stroke,
            x: rectWidth * j,
            y: rectHeight * i,
          })
        }
        this.gridConfiguration.push(rowConfig)
      }
    },
  },
  mounted() {
    this.generateProportionalGrid(this.columns, this.rows, this.width, this.height)
    this.updateInterval = setInterval(() => {
      this.generateProportionalGrid(this.columns, this.rows, this.width, this.height)
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.updateInterval)
  }
}
</script>

<style scoped>

</style>